<section class="ticket-content-container">
  <div class="custom-icon close" [mat-dialog-close]="false"></div>
  <section class="form-type-container">
    <form [formGroup]="locationNameFormGroup" (ngSubmit)="saveLocationName()">
      <h1>Edit Location Name</h1>
      <div class="location-address">
        <div class="custom-icon location_dark">location icon</div>
        {{ dialogData.locationAddress }}
      </div>
      <div class="input-label">
        <span>Current Name</span>
      </div>
      <mat-form-field class="location-name-alias">
        <mat-label>Enter new name</mat-label>
        <input
          matInput
          formControlName="locationNameAlias"
          rows="1"
          (keyup.enter)="saveLocationName()"
        />
      </mat-form-field>
      @if (hasError()) {
        <mat-error>
          <strong>Error:</strong> Location name was not saved. Please try
          again!</mat-error
        >
      }
      <div class="button-wrapper">
        <button
          class="btn-secondary mr-2"
          (click)="deleteLocationAlias()"
          [disabled]="isSaving()"
        >
          Delete
        </button>
        <button
          class="btn-primary"
          (click)="saveLocationName()"
          [disabled]="isSaving()"
        >
          Save
        </button>
      </div>
    </form>
  </section>
</section>
